/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_End_RoundInputs */



/**
* | output |
* | --- |
* | "End Round" |
*
* @param {Rounds_End_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_end_round = /** @type {((inputs?: Rounds_End_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_End_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Terminer la ronde")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalizar ronda")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Encerrar Rodada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Termina Round")
	return /** @type {LocalizedString} */ ("End Round")
});